export const ukPlaceId = 'ChIJqZHHQhE7WgIReiWIMkOg-MQ';

// At present the UK place object has a geometry viewport well outside
// the expected bounds, this overrides the viewport with specific coordinates.
export default () => ({
  getNorthEast: () => ({
    lat: () => 60.9,
    lng: () => 2.1,
  }),
  getSouthWest: () => ({
    lat: () => 49.8,
    lng: () => -8.9,
  }),
});



// WEBPACK FOOTER //
// ./app/src/components/Placepicker/getUKViewport.js